<template>
  <div class="switch" :class="{on: on}"></div>
</template>

<script>
export default {
  name: "SwitchHandle",
  props: {
    on: Boolean
  }
}
</script>

<style lang="scss">
.side-menu .switch {
  height: 1.05em;
  width: 2.2em;

  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.10);

  transition: background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;

  &::after {
    content: "";
    display: block;
    width: 0.78em;
    height: 0.78em;
    border-radius: 100%;

    background: var(--im-muted, var(--theme-bg));
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);

    position: relative;
    top: 0.08em;
    left: 0.12em;

    transition: left 0.25s ease, background 0.25s ease;
  }

  &.on {
    background: linear-gradient(135deg, rgba(55, 242, 154, 0.38), rgba(67, 217, 255, 0.26));
    border-color: rgba(67, 217, 255, 0.34);
    box-shadow: 0 0 22px rgba(55, 242, 154, 0.12);

    &::after {
      left: 1.22em;
      background: var(--im-text, #fff);
    }
  }
}
</style>